module.exports = __webpack_public_path__ + "static/media/52793024_2452989464776230_4195275551667126272_o.97fa53d8.jpg";